import * as types from '../actions/actionTypes'

export default function sprintTournamentReducer(state = [], action) {
    switch (action.type) {
        case types.sprintTournament.GET_SPRINTTOURNAMENT_STARTLIST_SUCCESS:
            return { ...state, sprintTournamentStartList: action.startlist }

        case types.sprintTournament.GET_SPRINTTOURNAMENT_RESULTS_SUCCESS:
            return { ...state, sprintTournamentResultList: action.results }

        default:
            return state;
    }
}